import React, { useEffect, useState } from 'react'
import { Compass, Ship, ArrowRight, MessageSquare, PawPrint } from 'lucide-react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';

import { Autoplay, Navigation } from 'swiper/modules';

import { Users2, Award, UserCheck, Wind, Users, ChevronLeft } from 'lucide-react';
import {  Zap, MousePointerClick, Heart } from "lucide-react";
import {  Film,  MapPin, Anchor, Star } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";

import {  Maximize, ChevronRight } from "lucide-react";

// import {    Sunset } from 'lucide-react';
import {    Shield } from 'lucide-react';

import FAQSection from '../Components/FAQSection';
import IndiaBoatsTopBar from '../Components/IndiaBoatsTopBar';
import PremiumNavbar from '../Components/PremiumNavbar';
import { useNavigate } from 'react-router-dom';
import { getMainImageUrl } from '../utils/fleetCardMedia';

const SBFaqs = [
  {
    question: "Can I book a private speed boat from Mumbai by boat name?",
    answer: "Yes. This page should display actual speed boat names from the database so guests can browse and book a specific boat directly."
  },
  {
    question: "What guest capacities are available for speed boat booking?",
    answer: "You can explore speed boat options for 6, 8, 10, 12, 15 and 18 guests."
  },
  {
    question: "Are speed boat transfers available from Mumbai to Mandwa and Alibaug?",
    answer: "Yes. Private speed boat transfers from Mumbai to Mandwa and Alibaug are available for guests looking for fast and convenient sea travel."
  },
  {
    question: "Do you offer private speed boat trips to Elephanta?",
    answer: "Yes. Private speed boat trips from Mumbai to Elephanta are available for sightseeing, family visits and private island travel."
  },
  {
    question: "Will each speed boat card have a direct booking link?",
    answer: "Yes. Each speed boat listing card should include a direct Book Now link along with a View Details option."
  },
  {
    question: "What information should each speed boat card show?",
    answer: "Each card should show the boat name, image, guest capacity, route suitability, short description and booking link."
  },
  {
    question: "Can I compare speed boats by guest capacity?",
    answer: "Yes. The page should help guests compare speed boat options based on capacity and route suitability."
  },
  {
    question: "Is a private speed boat booking from Mumbai safe?",
    answer: "Yes. Indiaboats places strong emphasis on trained crew, guest support and responsible operations."
  },
  {
    question: "How do I enquire if I am not sure which speed boat to choose?",
    answer: "You can contact Indiaboats through the enquiry form or WhatsApp with your date, number of guests and route."
  }
];

const mumbaiCategories = [
  { 
    id: "01",
    title: "Gateway Express Speedboat",
    category: "Fast Water Taxis",
    capacity: "Up to 6 Passengers",
    dimensions: "18 to 22 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Mandwa Transfers",
    desc: "A rapid, open-cockpit planning hull ideal for swift point-to-point transfers across Mumbai harbor with minimal transit time.",
    imgUrl: "assets/img/speed_boat_img1.png",
    type: "High-Speed Commute"
  },
  {
    id: "02",
    title: "Mandwa Commuter Pro",
    category: "Enclosed Speedboats",
    capacity: "Up to 8 Passengers",
    dimensions: "24 to 28 feet",
    cabins: "-NA-",
    washroom: "1 Washroom",
    goodFor: "Business Transits",
    desc: "Features a fully sheltered passenger cabin protecting travelers from sea spray while maintaining high cruising velocities.",
    imgUrl: "assets/img/speed_boat_img2.png",
    type: "All-Weather Transit"
  },
  {
    id: "03",
    title: "Khanderi Offshore Rib",
    category: "Rigid Inflatable Boats",
    capacity: "Up to 10 Passengers",
    dimensions: "22 to 26 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Thrill Transits",
    desc: "Heavy-duty military-grade rigid hulls optimized for high-velocity thrill rides and reliable island hopping.",
    imgUrl: "assets/img/speed_boat_img3.png",
    type: "Raw Speed Performance"
  },
  {
    id: "04",
    title: "Harbor Interceptor Cruiser",
    category: "Twin-Engine Cruisers",
    capacity: "Up to 12 Passengers",
    dimensions: "30 to 35 feet",
    cabins: "1 Small Cabin",
    washroom: "1 Washroom",
    goodFor: "VIP Coastal Transits",
    desc: "Powered by dual outboard motors, offering exceptional stability and luxury seating for delegations heading down-coast.",
    imgUrl: "assets/img/speed_boat_img4.png",
    type: "Balanced Velocity"
  },
  {
    id: "05",
    title: "Alibaug Luxury Shuttle",
    category: "Premium Fast Yachts",
    capacity: "Up to 15 Passengers",
    dimensions: "38 to 45 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Family Getaways",
    desc: "Blends deep-V offshore capability with high speed, ensuring a premium, upscale transit experience across the bay.",
    imgUrl: "assets/img/speed_boat_img1.png",
    type: "Elite Speed & Luxury"
  },
  {
    id: "06",
    title: "Elephanta Bulk Transport",
    category: "High-Capacity Shuttles",
    capacity: "Up to 18 Passengers",
    dimensions: "46 to 52 feet",
    cabins: "-NA-",
    washroom: "1 Washroom",
    goodFor: "Large Group Transfers",
    desc: "A wide-beamed, high-stability heavy speedboat layout designed to transport larger tourist and corporate groups efficiently.",
    imgUrl: "assets/img/speed_boat_img2.png",
    type: "Group Speed Shuttle"
  }
];

const goaCategories = [
  {
    id: "g01",
    title: "Mandovi River Rocket",
    category: "Fast Water Taxis",
    capacity: "Up to 6 Passengers",
    dimensions: "18 to 22 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Casino Transits",
    desc: "Agile, nimble speedboat designed for quick point-to-point shuttle operations across Panaji backwaters and river networks.",
    imgUrl: "assets/img/speed_boat_img3.png",
    type: "Swift Inland Transit"
  },
  {
    id: "g02",
    title: "Zuari Rapid Commuter",
    category: "Fast Water Taxis",
    capacity: "Up to 8 Passengers",
    dimensions: "20 to 24 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Inter-River Connections",
    desc: "A highly responsive craft constructed specifically to navigate shallow waters and narrow Goan estuarine systems quickly.",
    imgUrl: "assets/img/speed_boat_img2.png",
    type: "River Channel Express"
  },
  {
    id: "g03",
    title: "Goan Coastline Interceptor",
    category: "Rigid Inflatable Boats",
    capacity: "Up to 10 Passengers",
    dimensions: "24 to 30 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Dolphin Expeditions",
    desc: "Open-air extreme stability platform built to pierce through coastal breaks, ensuring quick and safe passenger delivery.",
    imgUrl: "assets/img/speed_boat_img4.png",
    type: "High-Stability Adventure"
  },
  {
    id: "g04",
    title: "Chorao Island Covered Shuttle",
    category: "Enclosed Speedboats",
    capacity: "Up to 12 Passengers",
    dimensions: "28 to 34 feet",
    cabins: "-NA-",
    washroom: "1 Washroom",
    goodFor: "Island Commutes",
    desc: "A spacious, completely covered passenger vessel perfect for keeping groups safe and dry during rapid river transfers.",
    imgUrl: "assets/img/speed_boat_img1.png",
    type: "Group Shuttle Format"
  },
  {
    id: "g05",
    title: "Arabian Sea Hydro-Sprint",
    category: "Premium Fast Yachts",
    capacity: "Up to 15 Passengers",
    dimensions: "45 to 52 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "VIP Relocations",
    desc: "An elite, aerodynamic speed vessel catering to high-end resort transfers and private, rapid coastal sightseeing.",
    imgUrl: "assets/img/speed_boat_img3.png",
    type: "Premium High-Speed Transit"
  },
  {
    id: "g06",
    title: "Grand Island Fast Wave",
    category: "Twin-Engine Cruisers",
    capacity: "Up to 18 Passengers",
    dimensions: "48 to 56 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Scuba Excursions",
    desc: "High-performance coastal cruiser optimized to cover immense distances down to South Goa beaches in record time.",
    imgUrl: "assets/img/speed_boat_img4.png",
    type: "Extended Range Speed"
  }
];

const mumbaiCategories2 = [
  {
    id: "m2_01",
    title: "Elephanta Speed Courier",
    category: "Fast Water Taxis",
    capacity: "Up to 6 Passengers",
    dimensions: "18 to 22 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Quick Excursions",
    desc: "Compact planing speedboat offering dynamic, nimble maneuvers for small families commuting to nearby harbor islands.",
    imgUrl: "assets/img/speed_boat_img4.png",
    type: "Express Harbor Shuttle"
  },
  {
    id: "m2_02",
    title: "Prongs Reef Storm-Rib",
    category: "Rigid Inflatable Boats",
    capacity: "Up to 8 Passengers",
    dimensions: "20 to 25 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Ocean Photography",
    desc: "Highly versatile shock-absorbing seating system paired with a responsive sports hull for rapid wave-cutting action.",
    imgUrl: "assets/img/speed_boat_img2.png",
    type: "High-Velocity Sport"
  },
  {
    id: "m2_03",
    title: "Uran Commercial Transit",
    category: "Enclosed Speedboats",
    capacity: "Up to 10 Passengers",
    dimensions: "26 to 30 feet",
    cabins: "-NA-",
    washroom: "1 Washroom",
    goodFor: "Executive Commutes",
    desc: "Weatherized commuter build designed to minimize fatigue for travelers on longer across-the-bay transit routes.",
    imgUrl: "assets/img/speed_boat_img3.png",
    type: "Deep Harbor Transit"
  },
  {
    id: "m2_04",
    title: "Vervati Premium Hydro-Yacht",
    category: "Premium Fast Yachts",
    capacity: "Up to 12 Passengers",
    dimensions: "42 to 48 feet",
    cabins: "1 Luxury Cabin",
    washroom: "1 Washroom",
    goodFor: "Executive Transfers",
    desc: "Top-tier high speed boat offering luxury leather interiors and soundproof enclosures for private executive transfers.",
    imgUrl: "assets/img/speed_boat_img1.png",
    type: "Sleek Aerodynamic Luxury"
  },
  {
    id: "m2_05",
    title: "Dharamtar High-Velocity Cruiser",
    category: "Twin-Engine Cruisers",
    capacity: "Up to 15 Passengers",
    dimensions: "32 to 38 feet",
    cabins: "1 Small Cabin",
    washroom: "1 Washroom",
    goodFor: "Corporate Transfers",
    desc: "Equipped with upgraded marine electronics and heavy outboards to safely accelerate coastal transfers.",
    imgUrl: "assets/img/speed_boat_img4.png",
    type: "Heavy-Duty Coastal Speed"
  },
  {
    id: "m2_06",
    title: "Thane Creek Jet-Shuttle",
    category: "High-Capacity Shuttles",
    capacity: "Up to 18 Passengers",
    dimensions: "48 to 54 feet",
    cabins: "-NA-",
    washroom: "1 Washroom",
    goodFor: "Industrial Crew Rotations",
    desc: "Reinforced hull structure optimized for fast multi-passenger commercial fleet dispatches across bay channels.",
    imgUrl: "assets/img/speed_boat_img2.png",
    type: "High-Velocity Utility"
  }
];

const goaCategories2 = [
  {
    id: "g2_01",
    title: "Anjuna Marine Hyper-Rib",
    category: "Rigid Inflatable Boats",
    capacity: "Up to 6 Passengers",
    dimensions: "20 to 24 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Water Sports Shuttles",
    desc: "Features structural safety configurations built to support continuous operations in high surf conditions along beaches.",
    imgUrl: "assets/img/speed_boat_img2.png",
    type: "Performance RIB"
  },
  {
    id: "g2_02",
    title: "Chapora Monarch Speed-Yacht",
    category: "Premium Fast Yachts",
    capacity: "Up to 8 Passengers",
    dimensions: "44 to 50 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Beach Club Transfers",
    desc: "Flawless sleek design meets powerful inner engineering. Reaches impressive speeds without sacrificing passenger refinement.",
    imgUrl: "assets/img/speed_boat_img1.png",
    type: "VIP Coastal Speed Concept"
  },
  {
    id: "g2_03",
    title: "Palolem Coast High-Flyer",
    category: "Twin-Engine Cruisers",
    capacity: "Up to 10 Passengers",
    dimensions: "34 to 40 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "North To South Goa",
    desc: "Heavy-caliber fiberglass planning structure designed to slide smoothly over choppy ocean rollers at maximum throttle.",
    imgUrl: "assets/img/speed_boat_img3.png",
    type: "Offshore Open Water Speed"
  },
  {
    id: "g2_04",
    title: "Divar Island Covered Shuttle",
    category: "Enclosed Speedboats",
    capacity: "Up to 12 Passengers",
    dimensions: "30 to 36 feet",
    cabins: "-NA-",
    washroom: "1 Washroom",
    goodFor: "Hotel Guest Shuttles",
    desc: "Optimized internally for maximum seating efficiency and panoramic glass visibility during high-speed transits.",
    imgUrl: "assets/img/speed_boat_img4.png",
    type: "High-Capacity Shuttle"
  },
  {
    id: "g2_05",
    title: "Nerul Stream Express",
    category: "Fast Water Taxis",
    capacity: "Up to 15 Passengers",
    dimensions: "36 to 42 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Rapid Resort Shuttles",
    desc: "Lightweight hull engineered with dynamic performance tracking for smooth and speedy navigation up shallow river estuaries.",
    imgUrl: "assets/img/speed_boat_img2.png",
    type: "Estuary Speed Taxi"
  },
  {
    id: "g2_06",
    title: "Vagator Coastal Jet-Cruiser",
    category: "High-Capacity Shuttles",
    capacity: "Up to 18 Passengers",
    dimensions: "50 to 55 feet",
    cabins: "1 Cabin",
    washroom: "2 Washrooms",
    goodFor: "Event VIP Group Transits",
    desc: "Large multi-engine custom platform built specifically to offer high-velocity relocations for premium wedding and event guests.",
    imgUrl: "assets/img/speed_boat_img1.png",
    type: "Premium Group Transit"
  }
];

const SpeedBoat = () => {
  const navigate = useNavigate();
  const capacities = [6, 8, 10, 12, 15, 18];
  const [activeTab, setActiveTab] = useState('mumbai');
    const [activeTab2, setActiveTab2] = useState('mumbai');
  const [luxuryMumbai, setLuxuryMumbai] = useState(mumbaiCategories);
  const [luxuryGoa, setLuxuryGoa] = useState(goaCategories);
  const [exploreMumbai, setExploreMumbai] = useState(mumbaiCategories2);
  const [exploreGoa, setExploreGoa] = useState(goaCategories2);
  const [fleetRevision, setFleetRevision] = useState(0);

  const getMediaUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/uploads/")) return path;
    return path;
  };

  const hasText = (value) => Boolean(String(value || "").trim());
  const layoutText = (card) =>
    [card.cabins, card.washroom]
      .map((value) => String(value || "").trim())
      .filter(Boolean)
      .join(" / ");
  const bookTripQuery = (tab) =>
    tab === "goa" ? "two-way" : "one-way";

  useEffect(() => {
    fetch("/api/experiences/SpeedBoat")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data) return;
        if (data.luxuryMumbai) setLuxuryMumbai(data.luxuryMumbai);
        if (data.luxuryGoa) setLuxuryGoa(data.luxuryGoa);
        if (data.exploreMumbai) setExploreMumbai(data.exploreMumbai);
        if (data.exploreGoa) setExploreGoa(data.exploreGoa);
        setFleetRevision((value) => value + 1);
      })
      .catch((error) => console.error("Experience fetch error:", error));
  }, []);
  
    const activeFleet = activeTab === 'mumbai' ? luxuryMumbai : luxuryGoa;
    const activeFleet2 = activeTab2 === 'mumbai' ? exploreMumbai : exploreGoa;

    // Active filter state
  const [selectedYachtCategory, setSelectedYachtCategory] = useState('All');

  

  // Unique variable name holding the curated private yacht options
  const privateYachtInventory = [
    {
      id: "yacht-01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-03",
      title: "Versatile Family Outing Yacht",
      category: "Mid Size Yachts",
      size: "Spacious versatile platform",
      capacity: "Up to 12 Guests",
      desc: "A balanced option offering more space, comfort and versatility for private outings, family leisure and special moments.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600"
    }
  ];

  // Dynamically extract unique categories for filter tabs
  const filterTabsList = ['All', 'Sail Boats', 'Compact Yachts', 'Mid Size Yachts', 'Premium Yachts', 'Bigger Sail Yachts'];

  // Filter logic based on tab state
  const filteredYachtsList = selectedYachtCategory === 'All' 
    ? privateYachtInventory 
    : privateYachtInventory.filter(yacht => yacht.category === selectedYachtCategory);


     // Active state to track the highlighted category
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  // Unique variable name for the updated explore categories data
  const exploreYachtSegments = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=1000",
      icon: <Wind size={20} />,
      amenities: ["Classic Rigging", "Open Deck Lounge", "Authentic Sea Breeze"]
    },
    {
      id: "02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1000",
      icon: <Ship size={20} />,
      amenities: ["Sunset Saloon", "Couples Daybed", "Express Cruising"]
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and comfortable private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=1000",
      icon: <Users size={20} />,
      amenities: ["Spacious Flybridge", "Multi-zone Audio", "Leisure Swim Platform"]
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=1000",
      icon: <Award size={20} />,
      amenities: ["Master Suite Cabin", "Gourmet Galley", "Exclusive Crew Service"]
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=1000",
      icon: <Compass size={20} />,
      amenities: ["Expansive Teak Decks", "High-performance Rigging", "Grand Dining Lounge"]
    }
  ];


const premiumYachtCategories = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=600",
      type: "Authentic Experience"
    },
    {
      id: "02",
      title: "Sunset Private Yacht Charter",
      category: "Compact Yachts",
      size: "Ideal for intimate premium experiences",
      capacity: "Up to 10 Guests",
      desc: "A compact private yacht charter in Mumbai ideal for couples, families and small groups looking for comfort, privacy and a memorable sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600",
      type: "Intimate Cruise"
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and comfortable private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600",
      type: "Versatile Comfort"
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600",
      type: "Signature Luxury"
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600",
      type: "Grand Voyage"
    }
  ];

  
  return (
    <>
        <IndiaBoatsTopBar/>
      <PremiumNavbar/>

          <div className="ib-page-wrapper">
             <div className="aeb-page-section-one">
      {/* 1. HERO HEADER */}
      <div className="aeb-page-section-one">   
      
    

   <section className="lyc-main-section" id='sb_section'>
      <div className="lyc-container lyc-section-container">
        
        {/* Navigation Tab Header Row */}
        <div className="lyc-header-navigation-block">
          <h1 className="idx-title" style={{ color: '#113d48',textAlign: 'center' }}>
               Speed Boat Transfers
              </h1>

               <div className="lyc-tabs-wrapper">
            
            <button 
              className={`lyc-tab-btn ${activeTab === 'mumbai' ? 'active' : ''}`}
              onClick={() => setActiveTab('mumbai')}
            >
              <MapPin size={14} />
              <span>1 way</span>
            </button>
            <button 
              className={`lyc-tab-btn ${activeTab === 'goa' ? 'active' : ''}`}
              onClick={() => setActiveTab('goa')}
            >
              <MapPin size={14} />
              <span>2 way </span>
            </button>
          </div>
          <div className="epyo-badge-row">
            <Anchor size={14} className="epyo-badge-icon" />
            <span className="epyo-pre-title">Mandwa / alibaug</span>
          </div>
         
          
        </div>

        {/* Swiper Slider Component */}
        <div className="lyc-swiper-wrapper" style={{ position: 'relative' }}>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={20}
        slidesPerView={4}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: ".lyc-swiper-prev-speedboat",
          nextEl: ".lyc-swiper-next-speedboat",
        }}
        breakpoints={{
          320: { slidesPerView: 1.25 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="lyc-swiper-instance"
        style={{ padding: '10px 10px' }}
        key={`luxury-${activeTab}-${fleetRevision}-${activeFleet.length}`}
      >
        {activeFleet.map((category) => (
          <SwiperSlide key={category._id || category.id}>
            <div className="lyc-card-v2">
              <div className="lyc-card-top-accent"></div>

              {/* Vertical Image Wrapper */}
              <div className="lyc-image-wrapper-v2">
                <img
                  src={getMediaUrl(getMainImageUrl(category))}
                  alt={category.title}
                  className="lyc-card-img-v2"
                />
                <div className="lyc-img-overlay"></div>
              </div>

              {/* Content Area */}
              <div className="lyc-card-content-v2">
                <div className="lyc-card-header">
                  <h3 className="lyc-card-title-v2">{category.title || category.category}</h3>
                  <span className="lyc-card-subtitle-tag">{category.type}</span>
                </div>

                {/* Expanded Specifications List */}
                <div className="lyc-card-specs-v2">
                  {hasText(category.capacity) && (
                    <div className="lyc-spec-row-v2">
                      <Users size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Guests:</span>
                      <span className="lyc-spec-val">{category.capacity}</span>
                    </div>
                  )}

                  {hasText(category.dimensions) && (
                    <div className="lyc-spec-row-v2">
                      <Maximize size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Size:</span>
                      <span className="lyc-spec-val">{category.dimensions}</span>
                    </div>
                  )}

                  {layoutText(category) && (
                    <div className="lyc-spec-row-v2">
                      <Compass size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Layout:</span>
                      <span className="lyc-spec-val">{layoutText(category)}</span>
                    </div>
                  )}

                  {hasText(category.goodFor) && (
                    <div className="lyc-spec-row-v2">
                      <Heart size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Good For:</span>
                      <span className="lyc-spec-val">{category.goodFor}</span>
                    </div>
                  )}

                  {category.petFriendly && (
                    <div className="lyc-spec-row-v2" style={{ marginLeft: '6px' }}>
                      <PawPrint size={14} className="epyo-metric-icon" />
                      <span className="epyo-metric-text">Pet Friendly</span>
                    </div>
                  )}
                </div>

                {/* Sleek Premium Button */}
                <div className="lyc-card-footer-v2">
                  <button
                    type="button"
                    className="lyc-sleek-btn"
                    onClick={() => {
                      if (category._id) {
                        navigate(
                          `/yachtdetails/${String(category._id)}?trip=${bookTripQuery(activeTab)}`
                        );
                      }
                    }}
                  >
                    <span className="lyc-btn-text">Book Now</span>
                    <span className="lyc-btn-icon-wrap">
                      <ChevronRight size={16} className="lyc-arrow-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Unique Navigation Buttons */}
      <button type="button" className="lyc-swiper-prev-speedboat" aria-label="Previous Slide">
        <ChevronLeft size={20} />
      </button>
      <button type="button" className="lyc-swiper-next-speedboat" aria-label="Next Slide">
        <ChevronRight size={20} />
      </button>
    </div>

      </div>
    </section>
     
      </div>


        <section className="lyc-main-section" id='sb_section_2'>
      <div className="lyc-container lyc-section-container">
        
        {/* Navigation Tab Header Row */}
        <div className="lyc-header-navigation-block">
          <div className="epyo-badge-row">
            <Anchor size={14} className="epyo-badge-icon" />
            <span className="epyo-pre-title">Elephanta</span>
          </div>
          <div className="lyc-tabs-wrapper">
            <button 
              className={`lyc-tab-btn ${activeTab2 === 'mumbai' ? 'active' : ''}`}
              onClick={() => setActiveTab2('mumbai')}
            >
              <MapPin size={14} />
              <span>1 way</span>
            </button>
            <button 
              className={`lyc-tab-btn ${activeTab2 === 'goa' ? 'active' : ''}`}
              onClick={() => setActiveTab2('goa')}
            >
              <MapPin size={14} />
              <span>2 way</span>
            </button>
          </div>
          
        </div>

        {/* Swiper Slider Component */}
        <div className="lyc-swiper-wrapper" style={{ position: 'relative' }}>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={20}
        slidesPerView={4}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: ".lyc-swiper-prev-explore",
          nextEl: ".lyc-swiper-next-explore",
        }}
        breakpoints={{
          320: { slidesPerView: 1.25 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="lyc-swiper-instance"
        style={{ padding: '10px 10px' }}
        key={`explore-${activeTab2}-${fleetRevision}-${activeFleet2.length}`}
      >
        {activeFleet2.map((category) => (
          <SwiperSlide key={category._id || category.id}>
            <div className="lyc-card-v2">
              <div className="lyc-card-top-accent"></div>

              {/* Vertical Image Wrapper */}
              <div className="lyc-image-wrapper-v2">
                <img
                  src={getMediaUrl(getMainImageUrl(category))}
                  alt={category.title}
                  className="lyc-card-img-v2"
                />
                <div className="lyc-img-overlay"></div>
              </div>

              {/* Content Area */}
              <div className="lyc-card-content-v2">
                <div className="lyc-card-header">
                  <h3 className="lyc-card-title-v2">{category.title || category.category}</h3>
                  <span className="lyc-card-subtitle-tag">{category.type}</span>
                </div>

                {/* Expanded Specifications List */}
                <div className="lyc-card-specs-v2">
                  {hasText(category.capacity) && (
                    <div className="lyc-spec-row-v2">
                      <Users size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Guests:</span>
                      <span className="lyc-spec-val">{category.capacity}</span>
                    </div>
                  )}

                  {hasText(category.dimensions) && (
                    <div className="lyc-spec-row-v2">
                      <Maximize size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Size:</span>
                      <span className="lyc-spec-val">{category.dimensions}</span>
                    </div>
                  )}

                  {layoutText(category) && (
                    <div className="lyc-spec-row-v2">
                      <Compass size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Layout:</span>
                      <span className="lyc-spec-val">{layoutText(category)}</span>
                    </div>
                  )}

                  {hasText(category.goodFor) && (
                    <div className="lyc-spec-row-v2">
                      <Heart size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Good For:</span>
                      <span className="lyc-spec-val">{category.goodFor}</span>
                    </div>
                  )}

                  {category.petFriendly && (
                    <div className="lyc-spec-row-v2" style={{ marginLeft: '6px' }}>
                      <PawPrint size={14} className="epyo-metric-icon" />
                      <span className="epyo-metric-text">Pet Friendly</span>
                    </div>
                  )}
                </div>

                {/* Sleek Premium Button */}
                <div className="lyc-card-footer-v2">
                  <button
                    type="button"
                    className="lyc-sleek-btn"
                    onClick={() => {
                      if (category._id) {
                        navigate(
                          `/yachtdetails/${String(category._id)}?trip=${bookTripQuery(activeTab2)}`
                        );
                      }
                    }}
                  >
                    <span className="lyc-btn-text">Book Now</span>
                    <span className="lyc-btn-icon-wrap">
                      <ChevronRight size={16} className="lyc-arrow-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation Controls */}
      <button type="button" className="lyc-swiper-prev-explore" aria-label="Previous Slide">
        <ChevronLeft size={20} />
      </button>
      <button type="button" className="lyc-swiper-next-explore" aria-label="Next Slide">
        <ChevronRight size={20} />
      </button>
    </div>

      </div>
    </section>

     

    <section className="sb-wrapper">
 
  {/* <section className="sb-premium-section">
  <div className="sb-container">
    <div className="sb-header">
      <h2 className="sb-title">Premium Boats</h2>
      <p className="sb-subtitle">Discover our curated fleet of premium private speed boats for your next Mumbai sea adventure.</p>
    </div>
    <div className="sb-grid">
      {[
        { 
          name: "Sea Eagle", 
          cap: "6 Guests", 
          desc: "Private speed boat option for couples, families and small groups.",
          img: "assets/img/sb1.png" 
        },
        { 
          name: "Ocean Pearl", 
          cap: "8 Guests", 
          desc: "Comfortable private transfer boat for small family and leisure travel.",
          img: "assets/img/sb2.png" 
        },
        { 
          name: "Blue Horizon", 
          cap: "10 Guests", 
          desc: "A practical option for group speed boat travel from Mumbai.",
          img: "assets/img/sb3.png" 
        },
        { 
          name: "Wave Runner", 
          cap: "12 Guests", 
          desc: "Suitable for family groups and premium private transfer requirements.",
          img: "assets/img/sb4.png" 
        },
        { 
          name: "Coastal Swift", 
          cap: "15 Guests", 
          desc: "Ideal for larger groups seeking a private and convenient sea transfer.",
          img: "assets/img/sb5.png" 
        },
        { 
          name: "Mariner Elite", 
          cap: "18 Guests", 
          desc: "Best for bigger groups looking for private speed boat booking from Mumbai.",
          img: "assets/img/sb6.png" 
        }
      ].map((boat, i) => (
        <div key={i} className="sb-card">
          <div className="sb-image-wrapper">
            
            <img src={boat.img} alt={boat.name} />
          </div>
          <div className="sb-card-content">
            <h3>{boat.name}</h3>
            <p className="sb-capacity"><strong>Capacity:</strong> {boat.cap}</p>
            <p className="sb-route"><strong>Route:</strong> Mumbai to Mandwa</p>
            <p className="sb-desc">A private speed boat from Mumbai ideal for {boat.desc.toLowerCase()}</p>
            <div className="sb-actions">
              <a href="#" className="sb-btn sb-btn-primary">Book Now</a>
              <a href="#" className="sb-btn sb-btn-secondary">View Details</a>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section> */}

  {/* EXPLORE SECTION */}
  <section className="sb-fleet-range-section">
      <div className="sb-fleet-range-container">
        
        {/* Modern Minimalistic Header Block */}
        <div className="sb-fleet-range-header">
          <div className="sb-range-badge">
            <Users2 size={14} className="sb-badge-icon" />
            <span className="sb-badge-text">Tailored Group Sizes</span>
          </div>
          <h2 className="sb-range-title">Explore by Capacity</h2>
          <div className="sb-range-decorator"></div>
        </div>

        {/* Premium Fluid Grid System */}
        <div className="sb-range-fluid-grid">
          {capacities.map((size) => (
            <div key={size} className="sb-range-luxury-card">
              <div className="sb-card-blur-bg"></div>
              <div className="sb-card-border-line"></div>
              
              <div className="sb-card-body-content">
                {/* Numeric Indicator Tag */}
                <div className="sb-capacity-pill-number">
                  <span className="sb-number-bold">{size}</span>
                  <span className="sb-number-label">Max Pax</span>
                </div>

                <div className="sb-card-text-group">
                  <h3 className="sb-capacity-headline">{size} Guests Capacity</h3>
                  <p className="sb-capacity-sub-paragraph">
                    Explore high-performance speed boats optimized for premium coastal transfers.
                  </p>
                </div>

                {/* Micro Action Trigger Button */}
                <div className="sb-action-trigger-wrapper">
                  <a href={`/fleet?capacity=${size}`} className="sb-premium-action-link">
                    <span className="sb-link-inner-text">View Available Fleet</span>
                    <span className="sb-arrow-icon-circle">
                      <ChevronRight size={14} className="sb-chevron-motion" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  {/* ROUTES SECTION */}
  {/* <section className="sb-routes-section">
    <div className="sb-container">
      <h2 className="sb-title">Popular Routes</h2>
      <div className="sb-routes-grid">
        {[
          { title: "Mumbai to Mandwa / Alibaug", desc: "Private speed boat transfers from Mumbai to Mandwa and Alibaug are ideal for guests looking for a faster, more convenient and more exclusive alternative to regular travel options." },
          { title: "Mumbai to Elephanta", desc: "Private speed boat trips from Mumbai to Elephanta are perfect for guests looking for a comfortable and flexible sea route for sightseeing, family visits and private island outings." }
        ].map((route, i) => (
          <div key={i} className="sb-route-card">
            <h3>{route.title}</h3>
            <p>{route.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section> */}
  </section>
     
      </div>



       

   

  

   <section className="ib-luxury-feature-wrapper">
  <div className="ib-luxury-feature-container">
    <div className="ib-luxury-feature-main-content">
      <h2 className="ib-luxury-feature-headline">
        Why Choose Indiaboats for Speed Boat Transfers
      </h2>
      <p>
        <span className="ib-luxury-feature-text-accent">Indiaboats</span> 
        offers bookable private speed boat transfers from Mumbai, making it easy to browse real boat options by name, compare guest capacity and choose the right boat for Mandwa, Alibaug or Elephanta travel. Whether you are planning a weekend transfer, a private island trip or premium family travel, this page helps you move quickly from browsing to booking.
      </p>
    </div>

    <div className="ib-luxury-feature-grid">
      {[
        { title: "Bookable Options", desc: "Bookable speed boat options from Mumbai", icon: <Ship size={24} /> },
        { title: "Live Listings", desc: "Actual boat names and live boat listings", icon: <Anchor size={24} /> },
        { title: "Flexible Capacity", desc: "Multiple guest capacities from 6 to 18 guests", icon: <Users size={24} /> },
        { title: "Popular Routes", desc: "Suitable for Mandwa, Alibaug and Elephanta routes", icon: <MapPin size={24} /> },
        { title: "Efficient Travel", desc: "Fast, private and convenient sea travel", icon: <Zap size={24} /> },
        { title: "Easy Booking", desc: "Easy browsing and direct booking flow", icon: <MousePointerClick size={24} /> }
      ].map((item, index) => (
        <div key={index} className="ib-luxury-feature-card">
          <div className="ib-luxury-feature-icon-box">{item.icon}</div>
          <div className="ib-luxury-feature-card-content">
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      

 <section className="pfUniqueMainSection">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: '2rem' }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
    </div>

    {/* Main Content Grid */}
    <div className="pfUniqueGridWrapper">
      {[
        "Mumbai to Mandwa speed boat transfers",
        "Mumbai to Alibaug private boat transfers",
        "Mumbai to Elephanta trips",
        "Family and group sea travel",
        "Weekend travel from Mumbai",
        "Premium private transfer bookings",
        
      ].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>



      

   <section className="wteUniqueMainSection">
  <div className="wteUniqueContainer">
    <div className="wteUniqueContentWrapper">
      <div className="wteUniqueLeftContent">
        <span className="wteUniqueMiniTitle">
          WHAT TO EXPECT
        </span>

        <h2 className="wteUniqueHeading">
          What to Expect with <span>Indiaboats</span>
        </h2>

        <p className="wteUniqueParagraph">
          Each speed boat listing on this page helps you explore real, bookable boat options in Mumbai based on boat name, guest capacity and route suitability. Whether you need a smaller private speed boat for a family transfer or a larger boat for a group trip, Indiaboats makes the booking process simple, clear and convenient.
        </p>
      </div>

      <div className="wteUniqueRightContent">
        {[
          "Real speed boat listings",
          "Bookable private transfer options",
          "Visible guest capacity",
          "Route-based travel suitability",
          "Suitable for families and groups",
          "Booking assistance and coordination",
          "Safety briefing and support"
        ].map((item, index) => (
          <div className="wteUniqueListCard" key={index}>
            <div className="wteUniqueCheckCircle">✓</div>
            <p className="wteUniqueListText">{item}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

<section className="sb-trips-wrapper">
  <div className="sb-trips-container">
    <div className="sb-trips-grid">
      
      {/* Mandwa Card */}
      <div className="sb-trip-card">
        <div className="sb-trip-icon">⚓</div>
        <h3>Trips to Mandwa / Alibaug</h3>
        <p>
          Mumbai to Mandwa and Alibaug speed boat transfers are popular for guests who want to save time and travel more comfortably by sea. These routes are especially useful for weekend plans, holiday travel, private group movement and premium short-distance coastal transfers.
        </p>
      </div>

      {/* Elephanta Card */}
      <div className="sb-trip-card">
        <div className="sb-trip-icon">🏝️</div>
        <h3>Trips to Elephanta</h3>
        <p>
          Mumbai to Elephanta speed boat trips are ideal for guests looking for a private and flexible route for sightseeing and island visits. This option is well suited for families, small groups and visitors who prefer a more comfortable and personalised travel experience on the water.
        </p>
      </div>

    </div>
  </div>
  </section>

     <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and <span>Service</span>
          </h2>

          <p className="scUniqueParagraph">
          At Indiaboats, safety is central to every speed boat transfer experience. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so every private speed boat booking from Mumbai is both enjoyable and professionally managed.
          </p>
        </div>
      </div>
    </section>

    <FAQSection
  pageKey="SpeedBoat"
  title="Frequently Asked Questions About Speed Boat"
  faqData={SBFaqs}
/>

 {/* <section className="igxMainCtaSection">
      <div className="igxMainCtaContainer">
        <div className="igxGlassCardWrapper">

        

          <h2 className="igxMainHeading">
           Book Your Private Speed Boat from <span>Mumbai</span>
          </h2>

          <p className="igxParagraphText">
          Browse available speed boat options by boat name, guest capacity and route to find the right private transfer for Mandwa, Alibaug or Elephanta.
          </p>

          <div className="igxButtonFlex">

            <button className="igxPrimaryActionBtn">
              <span>Book a Speed Boat </span>
            </button>

            <button className="igxOutlineActionBtn">
              <span>Explore Private Yacht Charters</span>
            </button>

            <button className="igxWhatsappActionBtn">
              <span>Request a Quote</span>
            </button>

          </div>
        </div>
      </div>
    </section> */}

     {/* <section className="btfUniqueSection">
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us What You’re <span>Planning</span>
             
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

       <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

  <div className="btfUniqueFieldBox">
  <label>Preferred Route</label>
  <select>
    <option value="">Select Route</option>
    <option value="sail-boat">Route 1</option>
    <option value="compact-yacht">Route 2</option>
    
  </select>
</div>

<div className="btfUniqueFieldBox">
  <label>Preferred Boat Name</label>
  <select>
    <option value="">Select Boat Name</option>
    <option value="sail-boat">Sail Boat</option>
    <option value="compact-yacht">Compact Yacht</option>
    <option value="mid-size-yacht">Mid-Size Yacht</option>
    <option value="premium-yacht">Premium Yacht</option>
    <option value="large-sail-yacht">Bigger Sail Yacht</option>
  </select>
</div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your private party requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Quote</span>
  </button>
</form>
        </div>
      </div>
    </section> */}

            </div>


<Footer/>
</>
  )
}

export default SpeedBoat
